import EventBus from '../../eventbus';
import mock from './mock';

export default function activity(app, data) {
  if (data === 'lazada_cancel') {
    EventBus.emit('cancelResult', {
      orderId: '**',
      itemId: '**',
      reason: '**',
      method: '**',
    });
    return true;
  }

  if (data === 'lazada_login') {
    EventBus.emit('login', {
      action: {},
      email: '**',
      type: 'registered  or guest',
      order_number: '***',
    });
    return true;
  }

  if (data === 'lazada_liveagent') {
    EventBus.emit('liveAgent', {
      imSid: '***',
    });
    return true;
  }


  if (data === 'eva') {
    app.appendMessage({
      type: 'evaluate',
      body: {
        title: 'Was it helpful?',
      },
    });
    return true;
  }

  // WHEN USER TYPE "TRACK MY ORDER" OR "CANCEL ORDER"
  // SHOW REQUEST LOGIN MESSAGE WITH LOGIN BUTTON
  if (data === 'lazada_request_login_message') {
    app.appendMessage({
      type: 'requestLoginMessage',
      body: {
        loginMessage: 'Please login for us to help you!',
        // loginParams: {
        //   action: {
        //     intentId: 1111,
        //     source: 'login_button',
        //   },
        //   email: null,
        //   type: 'registered',
        // },
      },
    });
    return true;
  }

  if (data === 'lazada_rar') {
    const orders = mock.rar.order2;
    const items = [];
    for (let i = 0; i < orders.length; i++) {
      for (let j = 0; j < orders[i].packages.length; j++) {
        items.push(...orders[i].packages[j].items);
      }
    }
    const action = items.length <= 3 ? 'appendMessage' : 'slideUpMessage';
    app[action]({
      type: 'rarList',
      body: { orders },
    });
    return true;
  }

  return false;
}



// WEBPACK FOOTER //
// ./src/app/context/channel/robot/activity.js